import Check from '@mui/icons-material/Check';
import Edit from '@mui/icons-material/Edit';
import Percent from '@mui/icons-material/Percent';
import { BaseModal } from '@src/common/components/BaseModal';
import { Divider } from '@src/common/components/Divider';
import { FloatInput } from '@src/common/components/FloatInput';
import { IconButton } from '@src/common/components/IconButton';
import { CloseConfirmModalFooter } from '@src/common/components/modal/CloseConfirmModalFooter';
import { Typography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import { useUpdateAdminFeeRate } from '@src/orders/review/hooks/useUpdateAdminFeeRate';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const EditAdminFeeRateButton = ({
  orderId,
  initialAdminFeeRate,
}: {
  orderId: string;
  initialAdminFeeRate: number;
}) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <>
      <IconButton
        style={{ padding: 0, paddingLeft: 8 }}
        onClick={openModal}
        title={t('editAdminFeesModal.title')}
      >
        <Edit />
      </IconButton>

      <EditAdminFeeRateModal
        orderId={orderId}
        open={modalOpen}
        onClose={closeModal}
        initialAdminFeeRate={initialAdminFeeRate}
      />
    </>
  );
};

const EditAdminFeeRateModal = ({
  orderId,
  open,
  onClose,
  initialAdminFeeRate,
}: {
  orderId: string;
  open: boolean;
  onClose: () => void;
  initialAdminFeeRate: number;
}) => {
  const { t } = useTranslation();
  const { updateAdminFeeRate, isPending } = useUpdateAdminFeeRate({ orderId });
  const [adminFeeRate, setAdminFeeRate] = useState<number | undefined>(
    undefined,
  );

  const saveAdminFee = () => {
    if (adminFeeRate !== undefined) {
      updateAdminFeeRate({ adminFeeRate });
    }
    onClose();
  };
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={t('editAdminFeesModal.title')}
    >
      <Typography style={{ ...theme.typography.body.medium }}>
        {t('editAdminFeesModal.description')}
      </Typography>
      <Divider
        style={{
          marginTop: theme.spacing['4'],
          marginBottom: theme.spacing['8'],
        }}
      />

      <FloatInput
        label={t('editAdminFeesModal.fieldLabel')}
        placeholder={t('editAdminFeesModal.fieldPlaceholder')}
        helperText={t('editAdminFeesModal.fieldHelperText', {
          defaultFeeInPercent: 4,
        })}
        initialValue={initialAdminFeeRate}
        onChanged={setAdminFeeRate}
        units={<Percent />}
      />

      <Divider
        style={{
          marginTop: theme.spacing['8'],
          marginBottom: theme.spacing['6'],
        }}
      />
      <CloseConfirmModalFooter
        onClose={onClose}
        confirm={saveAdminFee}
        confirmIcon={<Check style={{ marginRight: theme.spacing['2'] }} />}
        closeLabel={t('cancel')}
        confirmLabel={t('applyChanges')}
        confirmDisabled={isPending}
      />
    </BaseModal>
  );
};
